/* Dilip 12/05/2022  3031450488 Removed unecesarry console.log statements */
import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../util/Rest';
import {OPERATOR, RECORD_TYPE} from '../../constants/Lookup';
import download from '../../util/DownloadLink';

const initialData = {
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  filterDataStatus: null,
  filterData: {},
  addNoteStatus: null,
  userMetrix: '',
  addSuccessMsg: null,
  addFiltersData: {},
  addFiltersStatus: null,
  usageFilter: {},
  recordCodeData: {},
  FilterPrintStatus: null,
};

const slice = createSlice({
  name: 'DataManagerFilter',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postFilterData: (state, action) => {
      state.filterDataStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    postFiltersAddData: (state, action) => {
      state.addFiltersStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.addFiltersData = action.payload.response.placeResponse;
      state.addSuccessMsg = action.payload.message;
      state.userMetrix = action.payload.response.userMetrix;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getFilter: (state, action) => {
      state.filterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addMediaTypeStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
    getFilterUsage: (state, action) => {
      state.usageFilter = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchRecordCode: (state, action) => {
      state.recordCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postSystemNotesData: (state, action) => {
      state.addNoteStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    fetchAddSuccess: (state, action) => {
      state.addSuccessMsg = action.payload.message;
      state.isLoading = false;
    },
    resetFiltersStatus: (state, action) => {
      state.addFiltersStatus = null;
      state.addSuccessMsg = null;
    },
    resetMessage: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.FilterPrintStatus = null;
    },
    resetFilterUsagedata: (state, action) => {
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
      state.usageFilter = {};
    },
    resetData: (state, action) => {
      state.filterData = {};
    },
    resetStatus: (state, action) => {
      state.addNoteStatus = null;
      state.filterDataStatus = null;
      state.isLoading = false;
      // state.filterData = {};
    },

    // Print filter
    setFilterPrintData: (state, action) => {
      state.isLoading = false;
      state.FilterPrintStatus = action.payload.status;
      state.successMsg = action.payload.response;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  fetchDropDownData,
  fetchStart,
  fetchError,
  postFilterData,
  resetMessage,
  getFilter,
  postSystemNotesData,
  fetchSuccess,
  resetStatus,
  resetData,
  fetchRecordCode,
  postFiltersAddData,
  fetchAddSuccess,
  resetFiltersStatus,
  getFilterUsage,
  resetFilterUsagedata,
  setFilterPrintData,
} = slice.actions;

export const fetchFilterUsage = (name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`enableintegration/usage/enablefilters/${name}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getFilterUsage(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('lookup/find/all/lookup', {
      typeCode: [OPERATOR, RECORD_TYPE],
    })
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDropDownData(data.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getRecordCode = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet('dmrecord/find/all/recordcodeanddescription')
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchRecordCode(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const saveFilter = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost('dmfilter/save/datamanagerfilter', details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200 && data?.response?.userMetrix) {
          dispatch(postFiltersAddData(data));
          dispatch(fetchAddSuccess(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(postFilterData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchFilter = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`dmfilter/get/datamanagerfilter/${id}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getFilter(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const AddNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`dmfilter/save/filternotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const ResetMessage = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};
export const ResetStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const Resetdata = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const ResetFiltersRule = () => {
  return (dispatch) => {
    dispatch(resetFiltersStatus());
  };
};

export const printFilter = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`enableintegration/print/actioncondition`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postFilterPrint({dockey: data?.message}, data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postFilterPrint = (payload, postRuleGroupData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`enableintegration/generateurlprintIntegrationfilter`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setFilterPrintData(postRuleGroupData));
          download(data.data);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
